import { render, staticRenderFns } from "./PageAddSector.vue?vue&type=template&id=43a673f3&scoped=true&"
import script from "./PageAddSector.vue?vue&type=script&lang=ts&"
export * from "./PageAddSector.vue?vue&type=script&lang=ts&"
import style0 from "./PageAddSector.vue?vue&type=style&index=0&id=43a673f3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43a673f3",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VContainer,VForm,VSelect,VTextField})
